'use strict';

angular.module('shiftTraderApp')
    .controller('DaysOffTopCtrl', function($scope, AvailabilityRules, TimeService, $state, $stateParams, $location,
                                           SAErrorHandler, $timeout, me, daysOff, org,
                                           Session, allMinUsers, $interval, DaysOffUserStatsService, WorkPeriods,
                                           DaysOffRouteSyncService, UserPermissionsService, $uibModal) {



    $scope.me = me;
    $scope.org = org;

    $scope.allDepartments = _.map($scope.org.departments, function(dept) {
      dept._selected = true;
      return dept;
    });

    $scope.allMinUsers = _.sortBy(_.map(_.where(allMinUsers, function(u) {
      return u.$curMemb().active === 1;
    }), function(u) {
      u._filteredDayOffCount = 0;
      return u;
    }), 'first_name');

    $scope.nowDate = TimeService.getNowInStoreTime();

    var theDate = $stateParams.date;

    if (!theDate) {
      theDate = Session.getCurrentCalendarDate();
    }

    $scope.currentDate = TimeService.getBeginningOfDayFromDate(moment.utc(theDate)).startOf('month');
    $scope.workDayStartHour = Session.getWorkDayStartHour();

    $scope.state = {
      communicationDrawerOpen: false,
      selectedDepartments: _.cloneDeep($scope.org.departments),
      focusedOnUser: !_.isNull($stateParams.userId) && $stateParams.userId !== NaN && $stateParams.userId !== undefined && $stateParams.userId !== '',
      selectedStatuses: {
        approved: true,
        pending: true,
        disapproved: true
      },
      workPeriodsReturned: false,
      rawPermissions: null,
      derivedPermissions: null
    };

    $scope.state.currentView = ($state.current.name.split('.').length === 4) ? _.last($state.current.name.split('.')) : (_.last($state.current.name.split('.')) === 'pendingList' ? 'pendingList' : 'pending');

    var permissionsToLookUp = [
      'day_off_limits.create',
      'day_off_limits.update',
      'days_off.edit_policy'
    ];

    function processRawPermissions() {
      var rawPerms = $scope.state.rawPermissions;

      $scope.state.derivedPermissions = {
        canCreateLimits: rawPerms['day_off_limits.create'],
        canUpdateLimits: rawPerms['day_off_limits.update'],
        canManageLimits: rawPerms['day_off_limits.create'] || rawPerms['day_off_limits.update'],
        canEditDayOffPolicy: rawPerms['days_off.edit_policy']
      };
    }

    UserPermissionsService.getCanDict(permissionsToLookUp, $scope.org.id)
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;

        processRawPermissions();
      });

    $scope.changeView = function(viewName) {
      if ($scope.state.currentView !== viewName) {
        $scope.state.currentView = viewName;

        Session.setLastUsedDaysOffView(viewName);

        if (viewName === 'pendingList') {
          $state.go('daysOff.intermediate.pendingList', {}, {reload: true});
        } else {
          $state.go('daysOff.intermediate.date.' + viewName, {
            date: moment($scope.currentDate).format('YYYY-MM-DD')
          });
        }
      }
    };

    $scope.toggleDepartmentSelection = function(idx) {
      $scope.allDepartments[idx]._selected = !$scope.allDepartments[idx]._selected;
      if (!$scope.allDepartments[idx]._selected) {
        var idy = _.findIndex($scope.state.selectedDepartments, {id: $scope.allDepartments[idx].id});
        $scope.state.selectedDepartments.splice(idy, 1);
      } else {
        $scope.state.selectedDepartments.push($scope.allDepartments[idx]);
      }

      DaysOffRouteSyncService.setFilters({
        department_ids: _.pluck($scope.state.selectedDepartments, 'id')
      });
    };

    $scope.goBackMonth = function() {
      $state.go('daysOff.intermediate.date.' + $scope.state.currentView, {
        date: moment($scope.currentDate).subtract(5, 'days').startOf('month').format('YYYY-MM-DD'),
        userId: $scope.state.relevantUserId
      });
    };

    $scope.advanceMonth = function() {
      $state.go('daysOff.intermediate.date.' + $scope.state.currentView, { date: moment($scope.currentDate).add(35, 'days').startOf('month').format('YYYY-MM-DD'),
        userId: $scope.state.relevantUserId
      });
    };

    $scope.openPolicyModal = function() {
      var modalInstance = $uibModal.open({
        size: 'policy',
        templateUrl: 'views/dayOffPolicyModal.html',
        controller: 'dayOffPolicyModal',
        controllerAs: 'vm',
        resolve: {
          params: function() {
            return {
              me: $scope.me,
              org: $scope.org,
              canEdit: $scope.state.derivedPermissions.canEditDayOffPolicy
            };
          }
        }
      });

      modalInstance.result.then(function(org) {
        Session.getCurrentOrg(true)
          .then(function(org) {
            $scope.org = org;
          })
      });
    };

  });
